import React, { useState, useEffect } from 'react';
import '../styles/cookies-policy.css';

const CookiesPolicy = () => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		//check if the user has already accepted the policy
		const cookiesAccepted = localStorage.getItem('cookiesAccepted');
		if (!cookiesAccepted) {
		setIsVisible(true);
		}
	}, []);

	const handleAccept = () => {
		localStorage.setItem('cookiesAccepted', 'true');
		setIsVisible(false);
	};

	return (
		isVisible && (
			<div className="cookies-policy">
				<p>
					This website uses cookies to ensure you get the best experience. By using this site, you consent to the use of all cookies.
				</p>
				<button onClick={handleAccept}>Close</button>
			</div>
		)
	);
};

export default CookiesPolicy;
